"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.get = void 0;

var http_1 = require("./http");

var uri = '/v5/configuration/';

function get(id, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + id).then(function (resp) {
    return resp.data;
  });
}

exports.get = get;

function create(config, credentials) {
  return http_1.authorizedHTTP(credentials).post(uri, config).then(function (resp) {
    return resp.data;
  });
}

exports.create = create;